var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialui(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6L9 12.1667V43L0 36.8333V6Z",
    fill: "#29B6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29L61 35.1176V55L70 48.8824V29Z",
    fill: "#0288D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70 8L61 13.8182V24L70 18.1818V8Z",
    fill: "#0288D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6L43 12.1667V43L52 36.8333V6Z",
    fill: "#0288D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5L26 33V22.5L0 6V16.5Z",
    fill: "#29B6F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16.5L26 33V22.5L52 6V16.5Z",
    fill: "#0288D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52 37.8889L26 55V44.1111L52 27V37.8889Z",
    fill: "#0288D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 50.5L44 67V56.5L70 40V50.5Z",
    fill: "#0288D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44 56.0958L26 44V54.9042L44 67V56.0958Z",
    fill: "#29B6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialui);
export default __webpack_public_path__ + "static/media/materialui.c7c858dc76af369b97a5db266f13b4ca.svg";
export { ForwardRef as ReactComponent };